export default __webpack_public_path__ + "static/media/BG-Yellow-0002.5345236a.png";